import { toast } from "react-toastify";
import { base64ToBlob, uploadBlob } from "../../../helpers";
import {
    SR_PROFILE_PHOTO_BUCKET,
    SR_PROFILE_PHOTO_UPLOAD_DIR,
} from "../sr-constants";
import { checkSrFace, decideSrFace } from "./sr-face-check-api";
import type { SrFaceCheckResult, SrFaceDecision, SrFaceDecisionResult } from "./sr-face-check-types";

type ApiClient = { post: (path: string, body: object) => Promise<any> };

export const uploadVoterPhoto = async (
    capturedImage: string,
    voterId: string,
    projectId: number | string
): Promise<string> => {
    const uploadPath = `${SR_PROFILE_PHOTO_UPLOAD_DIR}/${projectId}`;
    const result: any = await uploadBlob(
        uploadPath,
        `${voterId}.png`,
        base64ToBlob(capturedImage),
        SR_PROFILE_PHOTO_BUCKET
    );
    if (!result?.key) throw new Error("Photo upload failed.");
    // Prefer S3 client key; fall back to constructed path for subject profile_photo
    return String(result.key || `${uploadPath}/${voterId}.png`);
};

export const runFaceCheck = async (
    api: ApiClient,
    projectId: number | string,
    photoUrl: string,
    voterId: string
): Promise<SrFaceCheckResult> =>
    checkSrFace(api, {
        projectid: Number(projectId),
        s3_link: photoUrl,
        voterid: voterId,
    });

export const runFaceDecision = async (
    api: ApiClient,
    projectId: number | string,
    photoUrl: string,
    matchedVoterId: string,
    decision: SrFaceDecision
): Promise<SrFaceDecisionResult> =>
    decideSrFace(api, {
        projectid: Number(projectId),
        voterid: matchedVoterId,
        s3_link: photoUrl,
        decision,
    });

export const requireVoterAndProject = (voterId: string, projectId?: number | string | null) => {
    if (!voterId) {
        toast.error("Voter ID is required to save the voter photo.");
        return false;
    }
    if (!projectId) {
        toast.error("Active project is required to save the voter photo.");
        return false;
    }
    return true;
};
